import { Card, CardMedia, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(theme => ({
  root: { display: 'flex' },
  cover: {
    width: 151
  }
}))

const FileCard = ({ file }: { file: File }) => {
  const classes = useStyles()
  return (
    <Card className={classes.root} elevation={3} variant="outlined">
      <img
        src={
          file.type.startsWith('image')
            ? URL.createObjectURL(file)
            : 'https://www.google.com/url?sa=i&url=https%3A%2F%2Ficons8.com%2Ficons%2Fset%2Ffile&psig=AOvVaw3y33VU5QdLV54VqaxEQatz&ust=1616582624956000&source=images&cd=vfe&ved=0CAIQjRxqFwoTCMDdoOCdxu8CFQAAAAAdAAAAABAE'
        }
        height="100px"
        width="100px"
        style={{ marginRight: 15 }}
        alt=""
      />
      <div>
        <div>
          Filename: <span>{file.name}</span>
        </div>
        <div>
          Size: <span>{file.size}</span>
        </div>
        <div>
          Type: <span>{file.type}</span>
        </div>
      </div>
    </Card>
  )
}

const FileUpload = () => {
  const [file, setFile] = React.useState<File | undefined>(undefined)
  return (
    <div style={{ height: 120 }}>
      <input
        type="file"
        onChange={e => {
          setFile(e.target.files?.[0])
        }}
      />
      {file && <FileCard file={file} />}
    </div>
  )
}

export default FileUpload
